/**
 * Links that leave this app for WordPress.
 *
 * `/my-account` is not a route in this build — it is answered by WordPress,
 * reverse-proxied through the Worker on the same hostname (see `src/worker.ts`
 * and `run_worker_first` in `wrangler.toml`). SvelteKit's client router does not
 * know that. It intercepts any same-origin `<a>`, pushes the new URL, finds no
 * matching route and renders nothing — so the address bar changed to
 * `/my-account` while the page the visitor was reading stayed exactly where it
 * was. Typing the same URL worked, because that is a document load and never
 * reaches the router.
 *
 * `data-sveltekit-reload` is what tells the router to hand the navigation back to
 * the browser. The language switcher carries it for a related reason: crossing a
 * locale needs a full document load, not a client-side render.
 *
 * Keep this list in step with `WORDPRESS_PREFIXES` in `src/worker.ts` — anything
 * proxied and linked from the UI belongs here. Paths that are proxied but never
 * linked (`/wp-admin`, `/wp-login.php`) do not need an entry.
 */
const WORDPRESS_PATHS = ['/my-account'];

/**
 * The `data-sveltekit-reload` attribute value for a link, or `undefined` to leave
 * the attribute off entirely.
 *
 * Returning `''` rather than `true` matters: SvelteKit reads the attribute's
 * presence, and an empty value is present. `undefined` omits it, which is what
 * every ordinary in-app link wants — those should stay client-side navigations.
 */
export const reloadIfWordPress = (href: string | undefined): '' | undefined =>
	href && WORDPRESS_PATHS.some((path) => href === path || href.startsWith(`${path}/`))
		? ''
		: undefined;
